import { ReactComponent as TransactionOn } from "../../console/assets/icons/transactionOn.svg";
import { useAuthStore } from "../../console/store/useAuthStore";
import { LOGIN_PATH } from "../tenant";

/**
 * 지점 포털 레이아웃
 *
 * 본점 콘솔(console/components/common/Layout + navBar)과 동일한 구성.
 * 지점은 주문판매 하나만 쓰므로 메뉴가 한 개다.
 */
const BranchLayout = ({ children }: { children: React.ReactNode }) => {
    const name = useAuthStore(state => state.m_name);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = LOGIN_PATH;
    };

    return (
        <div className="flex">
            <div className="h-screen w-20 py-5 px-3 shadow-xl flex flex-col gap-7 relative">
                <p className="text-[#273219] text-xl font-bold text-center">원일</p>
                <div className="flex flex-col gap-7">
                    <div className="flex items-center flex-col gap-1">
                        <div className="w-[52px] h-[52px] rounded-xl flex items-center justify-center bg-primary3">
                            <TransactionOn />
                        </div>
                        <p className="text-center whitespace-nowrap text-primary2 font-bold">주문판매</p>
                    </div>
                </div>
                <div className="flex flex-col items-center absolute bottom-0 left-0 right-0 mb-3">
                    <button className="text-gray1 mb-2.5">{name}</button>
                    <button className="text-gray2 mb-3 underline" onClick={handleLogout}>
                        로그아웃
                    </button>
                </div>
            </div>
            <div className="flex-1">{children}</div>
        </div>
    );
};

export default BranchLayout;
